import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Movies from './components/Movies';
import Tvshows from './components/Tvshows';
// import { HashRouter, Routes, Route } from "react-router-dom";
import Playvideo from './components/Playvideo';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Search from './components/Search';

function App() {
  return (
    <div className="App bg-[#221F1F] text-[#F5F5F1] font-poppins h-screen overscroll-none">
      <Router>
        <Routes>
          <Route path="/playvideo/:mediaType/:mediaId" element={<Playvideo />} />
          <Route path="*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/movies" element={<Movies />} />
                <Route path="/tvshows" element={<Tvshows />} />
                <Route path="/search/:query" element={<Search />} />
              </Routes>
            </>
          } />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
